import React, { Component } from 'react';
import MainLayout from '../../../components/Layout/MainLayout';
import {
  AxiosDeleteSecretApi,
  AxiosGetSecretApi,
} from '../../../utils/fetchApi';
import { Table, Button, DatePicker, Select, message } from 'antd';
import './nhatky.scss';
import moment from 'moment';
import Card from '../../../components/Card';
import ModalWarning from '../../../components/CustomsAntd/ModalWarning';

export default class NhatKy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataTable: [],
      tenNguoiDung: [],
      pagination: { pageSize: 12, total: 200, current: 1 },

      user: undefined,
      objectId: undefined,
      rangeTime: [null, null],

      clickButton: true,
      startDate: null,
      endDate: null,

      query: '',

      isVisiableModal: false,
    };

    this.column = [
      {
        title: 'STT',
        dataIndex: 'key',
        width: '5%',
      },
      {
        title: 'Người dùng',
        dataIndex: 'user',
        width: '10%',
      },
      {
        title: 'Phòng ban',
        dataIndex: 'phongBan',
        width: '20%',
      },
      {
        title: 'Đối tượng',
        dataIndex: 'noiDung',
        width: '15%',
      },
      {
        title: 'Ngày',
        dataIndex: 'ngay',
        width: '10%',
        key: 'ngay',
        render: (text, record) => (
          <span>{moment(record.ngay).utc(0).format('DD/MM/YYYY')}</span>
        ),
      },
      {
        title: 'Giờ',
        dataIndex: 'ngay',
        key: 'gio',
        width: '10%',
        render: (text, record) => (
          <span>{moment(record.ngay).utc(0).format('HH:mm:ss')}</span>
        ),
      },
      {
        title: 'Kết quả',
        dataIndex: 'ketQua',
        width: '20%',
      },

      {
        title: 'Hành động',
        render: (cell, row, index) => {
          console.log(row);
          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'flex' }}>
                <Button
                  onClick={() => {
                    this.props.history.push(
                      `/nhat-ky/${row.OBJECTID}/chinh-sua`
                    );
                  }}
                  style={{ marginRight: '10px', padding: 0 }}
                  type='link'
                >
                  <i
                    className='fas fa-edit'
                    style={{ fontSize: '18px', color: '#1F86EB' }}
                  ></i>
                </Button>

                <Button
                  type='link'
                  onClick={() => {
                    this.showModalDelete(row.OBJECTID);
                  }}
                >
                  <i
                    className='far fa-trash-alt'
                    style={{ fontSize: '18px', color: 'red' }}
                  />
                </Button>
              </div>
            </div>
          );
        },
        align: 'center',
        width: 150,
      },
    ];
  }

  onSearchClick = async (e) => {
    this.setState({
      loading: true,
    });

    let query = '';
    let url = '';
    if (e === 'TimKiem') {
      url = `/api/nhat-ky/search?curPage=1&pageSize=12&`;
    } else {
      url = `/api/nhat-ky/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
    }

    if (this.state.user) {
      query = query + `user=${this.state.user}&`;
      url = url + `user=${this.state.user}&`;
    }

    if (this.state.startDate && this.state.startDate !== null) {
      let startTime = this.state.startDate.format('MM/DD/YYYY');
      query = query + `startDate=${new Date(startTime)}&`;
      url = url + `startDate=${new Date(startTime)}&`;
    }

    if (this.state.endDate && this.state.endDate !== null) {
      let endTime = this.state.endDate.format('MM/DD/YYYY');
      endTime = new Date(endTime).setHours(0, 0, 0, 0);
      endTime = new Date(endTime).getTime() + 24 * 3600 * 1000 - 1;
      query = query + `endDate=${new Date(endTime)}&`;
      url = url + `endDate=${new Date(endTime)}&`;
    }

    if (this.state.objectId) {
      query = query + `OBJECTID=${this.state.objectId}&`;
      url = url + `OBJECTID=${this.state.objectId}&`;
    }

    if (e === 'pagination') {
      url = `/api/nhat-ky/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
      query = this.state.query;
      url = url + query;
    }

    if (e === 'TimKiem') {
      this.setState({ query: query });
    }

    let response = await AxiosGetSecretApi(url);
    if (response) {
      response.dataResult = response.dataResult.map((o, index) => {
        return {
          ...o,
          key:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      this.setState({
        dataTable: response.dataResult,
        pagination: response.dataPaginate,
        loading: false,
      });
    }
  };

  async componentDidMount() {
    let response = await AxiosGetSecretApi('api/nhat-ky/all-username');
    let dataTenNguoiDung = [];
    if (response)
      dataTenNguoiDung = response.map((obj) => {
        return { value: obj.user, name: obj.user };
      });

    this.setState({ tenNguoiDung: dataTenNguoiDung });
    this.onSearchClick();
  }

  onChangeTable(e) {
    this.setState({
      pagination: e,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.pagination !== this.state.pagination) {
      if (prevState.pagination.current !== this.state.pagination.current) {
        this.onSearchClick('pagination');
      }
    }

    if (prevState.clickButton !== this.state.clickButton) {
      this.onSearchClick();
    }
  }

  resetButton() {
    this.setState({
      rangeTime: [null, null],
      user: undefined,
      objectId: undefined,
      pagination: { pageSize: 12, total: 200, current: 1 },
      clickButton: !this.state.clickButton,
      startDate: null,
      endDate: null,
      query: '',
    });
  }

  // chinh sua nhat ky

  showModalDelete(id) {
    this.setState({
      isVisiableModal: true,
      idNhatKy: id,
    });
  }

  onCancelModal = () => {
    this.setState({ isVisiableModal: false });
  };

  onDelete = async () => {
    let id = this.state.idNhatKy;
    this.setState({ isVisiableModal: false });
    try {
      let response = await AxiosDeleteSecretApi(`/api/nhat-ky/${id}`);
      if (response.success === true) {
        message.success(`Xóa nhật ký hoạt động thành công!`);
        this.resetButton();
      } else {
        message.error('Xóa nhật ký hoạt động không thành công');
      }
    } catch (error) {
      message.error('Xoá nhật ký hoạt động không thành công');
    }
  };

  render() {
    return (
      <MainLayout title={'Nhật ký hoạt động'} {...this.props}>
        <div className='page-with-card'>
          <Card title='Nhật ký hoạt động'>
            <div className='activity'>
              <div className='search-bar'>
                <div className='search-item username'>
                  <div className='sub-title'>Tên người dùng:</div>
                  <Select
                    className='select'
                    style={{ width: '100%' }}
                    onChange={(v) => {
                      this.setState({ user: v });
                    }}
                    showSearch
                    optionFilterProp='name'
                    notFoundContent='Không tìm thấy kết quả phù hợp'
                    value={this.state.user}
                  >
                    {this.state.tenNguoiDung.map((e, i) => (
                      <Select.Option value={e.value} name={e.name} key={i}>
                        {e.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div className='search-item date'>
                  <div className='sub-title'>Từ ngày:</div>
                  <DatePicker
                    className='date-picker'
                    showToday={false}
                    placeholder=' '
                    value={this.state.startDate}
                    onChange={(e) => {
                      this.setState({ startDate: e });
                    }}
                    dateFormat='DD/MM/YYYY'
                    style={{ width: '100%' }}
                    disabledDate={(current) => {
                      if (this.state.endDate && this.state.endDate !== null) {
                        return (
                          current && current >= this.state.endDate.endOf('day')
                        );
                      }
                      return current && current > moment().endOf('day');
                    }}
                    suffixIcon={
                      <i
                        className='far fa-calendar-alt'
                        style={{ fontSize: '16px' }}
                      ></i>
                    }
                  ></DatePicker>
                </div>

                <div className='search-item date'>
                  <div className='sub-title'>Đến ngày:</div>
                  <DatePicker
                    className='date-picker'
                    dateFormat='DD/MM/YYYY'
                    showToday={false}
                    placeholder=' '
                    value={this.state.endDate}
                    onChange={(e) => {
                      this.setState({ endDate: e });
                    }}
                    style={{ width: '100%' }}
                    disabledDate={(current) => {
                      if (
                        this.state.startDate &&
                        this.state.startDate !== null
                      ) {
                        if (
                          current < this.state.startDate.startOf('day') ||
                          current > moment().endOf('day')
                        ) {
                          return current;
                        }
                      }
                      return current && current > moment().endOf('day');
                    }}
                    suffixIcon={
                      <i
                        className='far fa-calendar-alt'
                        style={{ fontSize: '16px' }}
                      ></i>
                    }
                  ></DatePicker>
                </div>
              </div>

              <div className='gr-button' style={{ marginTop: '15px' }}>
                <Button
                  style={{
                    fontWeight: 'bold',
                    marginRight: '15px',
                  }}
                  type='primary'
                  onClick={() => {
                    this.resetButton();
                  }}
                >
                  Tìm mới
                </Button>
                <Button
                  style={{
                    fontWeight: 'bold',
                  }}
                  type='primary'
                  onClick={() => {
                    this.onSearchClick('TimKiem');
                  }}
                >
                  Tìm kiếm
                </Button>
              </div>

              <div style={{ marginTop: '20px' }}>
                <Table
                  columns={this.column}
                  dataSource={this.state.dataTable}
                  locale={{ emptyText: 'Không có dữ liệu' }}
                  bordered
                  pagination={{
                    ...this.state.pagination,
                    showSizeChanger: false,
                  }}
                  onChange={(e) => {
                    this.onChangeTable(e);
                  }}
                  size='small'
                />
              </div>

              {this.state.isVisiableModal && (
                <ModalWarning
                  visible={this.state.isVisiableModal}
                  title={'Bạn có chắc muốn xoá ?'}
                  onOk={this.onDelete}
                  onCancel={this.onCancelModal}
                ></ModalWarning>
              )}
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}
